import { I18nManager } from 'react-native';

type TimeFormatter = (startDate: Date, endDate: Date, is12HourClock: boolean) => string;

let timeFormatter: TimeFormatter;

export const setCustomTimeFormatter = (formatter: TimeFormatter) => {
    timeFormatter = formatter;
};

export const timeText = (
    startDate: Date,
    endDate: Date,
    is12HourClock: boolean,
    isLiveEvent?: boolean,
    isLive?: boolean,
    isSingleRow?: boolean
) => {
    if (timeFormatter) {
        return timeFormatter(startDate, endDate, is12HourClock);
    }
    let startHours = startDate.getHours();
    const startMinutes = startDate.getMinutes();
    let endHours = endDate.getHours();
    const endMinutes = endDate.getMinutes();
    const startampm = startHours >= 12 ? ' PM' : ' AM';
    const endampm = endHours >= 12 ? 'PM' : 'AM';

    if (is12HourClock) {
        startHours %= 12;
        endHours %= 12;
    }

    const [startHoursString, endHoursString, startMinutesString, endMinutesString] = [
        startHours,
        endHours,
        startMinutes,
        endMinutes,
    ].map((value) => (value < 10 ? `0${value}` : value.toString()));
    const startTime = `${startHoursString}:${startMinutesString}${is12HourClock ? startampm : ''}`;
    const endTime = `${endHoursString}:${endMinutesString} ${is12HourClock ? endampm : ''}`;

    if (isLive && isSingleRow) {
        const ltrText = `${startTime} - ${endTime}`;
        const rtlText = `${endTime} - ${startTime}`;
        return I18nManager.isRTL ? rtlText : ltrText;
    }

    if (isLiveEvent) {
        return startTime;
    }
    return `${startTime} - ${endTime}`;
};